import { instantOfWallClock } from "@thalamos/common";
import type { Dayjs } from "@thalamos/common";

/**
 * The instant UK clocks name with the date and time `value` shows, ignoring the
 * offset `value` carries: a date picker can hand back a summer date carrying
 * today's winter offset (https://github.com/mui/mui-x/issues/12535).
 */
export const ukInstantOfWallClock = (value: Dayjs): Dayjs =>
  instantOfWallClock({ wallClock: value.format("YYYY-MM-DD HH:mm:ss") });
